import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EstatusIndicador } from './estatusIndicadorCarga';

/**
 * Servicio que permite mostrar indicadores de carga al usuario.
 */
@Injectable()
export class ServicioIndicadorCarga {
    //#region Propiedades
    
    /** Evento que emite elementos cuando se solicita una pantalla de carga. */
    public onCambioEstatus = new Subject<EstatusIndicador>();

    /** Propiedad que indica si la pantalla de carga de mostrara en modo full screen. */
    public esFullScreen: boolean = false;
    
    //#endregion
    
    //#region Metodos publicos

    /**
     * Muestra un indicadores de carga con o sin mensaje.
     * @param mensaje Mensaje a mostrar en el indicador de carga.
     */
    public mostrar(mensaje?: string) {
        this.onCambioEstatus.next(<EstatusIndicador>{ esVisible: true, mensaje: mensaje, esFullScreen: this.esFullScreen });
    }

    /**
     * Oculta el indicador de carga.
     */
    public ocultar() {
        this.onCambioEstatus.next(<EstatusIndicador>{ esVisible: false });
    }

    /**
     * Establece el modo del indicador de carga (Full screen o no).
     */
    public setFullScreen(esFullScreen: boolean) {

        this.esFullScreen = esFullScreen;
    }
    
    //#endregion
}